export enum ETypePersonnePhysique {
	COLLABORATEUR = 'COLLABORATEUR',
	PARTENAIRE = 'PARTENAIRE',
	ENCADREUR = 'ENCADREUR',
	ETUDIANT = 'ETUDIANT',
	PARENT = 'PARENT',
	INSTITUTION = 'INSTITUTION'
}